var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-gap-q" }, [
    _c("p", { staticClass: "viq-gap-q__intro" }, [
      _vm._v(
        "\n    Answer the following questions to help VIQ identify compliance gaps. Select the most appropriate option for each.\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-gap-q__list" },
      _vm._l(_vm.questions, function (q, i) {
        return _c("div", { key: i, staticClass: "viq-gap-q__card" }, [
          _c("div", { staticClass: "viq-gap-q__card-num" }, [
            _vm._v(_vm._s(i + 1)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-gap-q__card-content" },
            [
              _c("h4", { staticClass: "viq-gap-q__card-question" }, [
                _vm._v(_vm._s(q.text || q.question || q)),
              ]),
              _vm._v(" "),
              q.options && q.options.length > 0
                ? _c(
                    "div",
                    { staticClass: "viq-gap-q__options" },
                    _vm._l(q.options, function (opt, j) {
                      return _c(
                        "label",
                        {
                          key: j,
                          staticClass: "viq-gap-q__option",
                          class: {
                            "viq-gap-q__option--selected":
                              _vm.answers[i] === (opt.value || opt),
                          },
                        },
                        [
                          _c("input", {
                            staticClass: "viq-gap-q__option-radio",
                            attrs: { type: "radio", name: "q-" + i },
                            domProps: { value: opt.value || opt },
                            on: {
                              change: function ($event) {
                                return _vm.setAnswer(i, opt.value || opt)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "viq-gap-q__option-indicator",
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "viq-gap-q__option-text" },
                            [_vm._v(_vm._s(opt.label || opt))]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      size: "small",
                      placeholder: "Your answer...",
                    },
                    model: {
                      value: _vm.answers[i],
                      callback: function ($$v) {
                        _vm.$set(_vm.answers, i, $$v)
                      },
                      expression: "answers[i]",
                    },
                  }),
            ],
            1
          ),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.isStreaming
      ? _c("div", { staticClass: "viq-gap-q__loading" }, [
          _c("span", { staticClass: "viq-gap-q__spinner" }),
          _vm._v("\n    Loading questions...\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isStreaming
      ? _c(
          "div",
          { staticClass: "viq-gap-q__actions" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", disabled: !_vm.allAnswered },
                on: { click: _vm.submit },
              },
              [_vm._v("\n      Analyse Gaps\n    ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }